import { useEffect, useState } from 'react'
import { sortBy } from 'ramda'
import { useEducationClient, useEducationFeature, handleEducationError } from 'education-tools'

export default function useContentRank(entries, limit = 5) {
  const client = useEducationClient()
  const [result, setResult] = useState(null)
  const targetedContentFeature = useEducationFeature('meg.uhqm.targeted-content')

  useEffect(() => {
    if (!entries || targetedContentFeature === null) {
      setResult(null)
    } else if (entries.length && targetedContentFeature) {
      const targetedContentTypes = (targetedContentFeature.contentTypes || '')
        .split(',')
        .filter(Boolean)
        .map(contentType => contentType.trim())

      const contentType = entries[0].contentType
      const isTargetedContentType = targetedContentTypes.includes(contentType)

      if (isTargetedContentType) {
        client
          .request({
            method: 'GET',
            url: `/v1/contentRank`,
            params: {
              contentType,
              limit
            }
          })
          // eslint-disable-next-line promise/always-return
          .then(response => {
            const rankedEntryIds = response.data.entryIds

            const sortedEntries = sortBy(entry => {
              const rankIndex = rankedEntryIds.indexOf(entry.id)
              return rankIndex === -1 ? rankedEntryIds.length : rankIndex
            }, entries)

            setResult(sortedEntries)
          })
          .catch(error => {
            setResult(entries)
            handleEducationError(error)
          })
      } else {
        setResult(entries)
      }
    } else {
      setResult(entries)
    }
  }, [JSON.stringify(entries), targetedContentFeature])

  return result
}
